const imp = () => import(/* webpackChunkName: "loadSprite_ESB_integration"*/  "../sprite/loadSprite_ESB_integration");
const loadMap_ESB_integration: { [key: string]: () => Promise<any> } = {
  "Icon-incrementalVariable": imp,
  "Icon-triggerEvent": imp,
  "Icon-decreasingVariable": imp,
  "Icon-timingTrigger": imp,
  "Icon-stringVariable": imp,
  "Icon-executeAction": imp,
  "Icon-dataMerging": imp,
  "Icon-variableAssignment": imp,
  "Icon-dataFiltering": imp,
}
export default loadMap_ESB_integration;